var React = require('react');

function ArrowBox (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#EA650D","fillRule":"evenodd","clipRule":"evenodd"},[React.createElement("path",{"d":"M22.895 2.422c0-.105 0-.105-.105-.21v-.106C22.79 2 22.685 2 22.58 2H14.6c-.315 0-.525.211-.525.528 0 .316.315.422.525.422h6.615L9.455 14.663a.512.512 0 0 0 0 .739c.21.211.525.211.735 0l11.76-11.82v6.65c0 .316.21.527.525.527.315 0 .525-.211.525-.528l-.105-7.809Z","key":0}),React.createElement("path",{"d":"M19.325 12.025c-.315 0-.525.211-.525.528v8.02c0 .739-.63 1.372-1.365 1.372H4.415c-.735 0-1.365-.633-1.365-1.372V7.382c0-.739.63-1.372 1.365-1.372H12.5c.315 0 .525-.211.525-.528 0-.316-.315-.527-.525-.527H4.415C3.05 4.955 2 6.01 2 7.382v13.19C2 21.946 3.05 23 4.415 23h13.02c1.365 0 2.415-1.055 2.415-2.427v-8.02c0-.211-.315-.528-.525-.528Z","key":1})]));
}

ArrowBox.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowBox;

ArrowBox.default = ArrowBox;
